import { type IBasicUser, type IMetaWrapper, type INewUser, type IUserExists } from '../types'
import { useUpFetch } from '../utils'

export const useUserApi = () => {
  const upFetch = useUpFetch()

  const addUser = async (user: INewUser) => {
    return upFetch<{ data: IBasicUser }>('/users', {
      body: user,
      method: 'POST',
    })
  }

  const inviteUser = async (user: INewUser) => {
    return upFetch<{ data: IBasicUser }>('/users/invite', {
      body: user,
      method: 'POST',
    })
  }

  const addUserToGroup = async (users_ids: number, group_type: string) => {
    const res = await upFetch(`/groups/users/add`, {
      body: {
        group_type,
        users_ids: [users_ids],
      },
      method: 'POST',
    })

    return !!res
  }

  const getUsers = async (params: Record<string, any>) => {
    return upFetch<{ data: IMetaWrapper<IBasicUser> }>('/users', {
      params: {
        i: 'groups,updated_at',
        ...params,
      },
    })
  }

  const editUser = async (userId: number | undefined, data: INewUser) => {
    return upFetch<{ data: IBasicUser }>(`/users/${userId}`, {
      body: data,
      method: 'PATCH',
    })
  }

  const userDeactivated = async (userId: number, status: number) => {
    return upFetch(`/users/${userId}/status/${status}`)
  }

  const fetchUsersByRole = async (role: string) => {
    return upFetch<IMetaWrapper<IBasicUser>>(`/users/${role}`, {
      params: {
        perPage: 999,
      },
    })
  }

  const companyCheckName = async (
    name: string,
  ): Promise<{ data: IUserExists } | { error: string }> => {
    return upFetch<{ data: IUserExists }>('/companies/exists', {
      body: {
        title: name,
      },
      method: 'POST',
    })
  }

  const getUser = async (userId: number) => {
    return upFetch<{ data: IBasicUser }>(`/users/${userId}`)
  }

  return {
    addUser,
    addUserToGroup,
    companyCheckName,
    editUser,
    fetchUsersByRole,
    getUser,
    getUsers,
    inviteUser,
    userDeactivated,
  }
}
